import * as React from 'react';

import { UitkIcon, UitkIconSize } from 'uitk-react-icons';
import { UitkLayoutFlex } from 'uitk-react-layout-flex';
import { UitkSpacing } from 'uitk-react-spacing';
import { UitkText } from 'uitk-react-text';

import { PropertyFields } from '__generated__/api';

export interface ListingAmenitiesProps {
  amenities?: PropertyFields.Amenities[];
}

export const ListingAmenities: React.FunctionComponent<ListingAmenitiesProps> = ({ amenities }) => {
  if (!amenities?.length) {
    return null;
  }

  return (
    <UitkSpacing margin={{ blockend: 'one' }}>
      <UitkLayoutFlex wrap="wrap" space="two">
        {amenities.map(amenity => (
          <UitkLayoutFlex alignItems="center">
            <UitkIcon name={amenity.icon} size={UitkIconSize.SMALL} />
            <UitkSpacing margin={{ inline: 'two', block: 'one' }}>
              <UitkText theme="default" size={200} inline={true}>
                {amenity.name}
              </UitkText>
            </UitkSpacing>
          </UitkLayoutFlex>
        ))}
      </UitkLayoutFlex>
    </UitkSpacing>
  );
};
